import { FC, useRef } from 'react'
import { useRadio } from '@chakra-ui/react'
import { Box, Text } from '../index'
import { RadioButtonProps } from './interfaces'
import theme from '../../styles'
import { RadioButton } from './radio-button'

export const SmallPillVerticalRadioButton: FC<RadioButtonProps> = (props) => {
  const { getInputProps, getRadioProps } = useRadio({ ...props, value: props.value?.toString() })
  const inputRef = useRef<HTMLInputElement>(null)

  const handleFocus = () => {
    if (inputRef.current) {
      inputRef.current.focus()
    }
  }

  return (
    <Box
      className="test"
      as="label"
      cursor="pointer"
      data-testid={`pill-${props.value}`}
      display="flex"
      justifyContent="center"
      alignItems="center"
      tabIndex={0}
      onFocus={handleFocus}
    >
      <Box {...getRadioProps()} aria-label={`button-${props.label}`} layerStyle={theme.LayerStyles.SMALL_PILL_VERTICAL}>
        <RadioButton {...getInputProps()} ref={inputRef} />

        <Text>{props.label}</Text>
      </Box>
    </Box>
  )
}
